import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import { NumberInputControl } from "../../controls";
import { H3Input } from "h3-mobile-vue";
let InputNumberRange = class InputNumberRange extends NumberInputControl {
    constructor() {
        super(...arguments);
        //是否显示数字键盘
        this.showKeyboard = false;
        //给每一个h3-input组件加上唯一标志 
        this.id = new Date().getTime();
    }
    get begin() {
        if (this.ctrl.value && this.ctrl.value.length > 1) {
            const val = this.ctrl.value[0];
            if (val !== null) {
                return val.toString();
            }
            return '';
        }
    }
    get end() {
        if (this.ctrl.value && this.ctrl.value.length === 2) {
            const val = this.ctrl.value[1];
            if (val !== null) {
                return val.toString();
            }
            return '';
        }
    }
    get beginId() {
        return this.id + 'begin';
    }
    get endId() {
        return this.id + 'end';
    }
    onBeginChange(val) {
        if (val) {
            const value = Number(val);
            if (!isNaN(value)) {
                if (!this.ctrl.value || this.ctrl.value.length === 0) {
                    this.ctrl.value = [value];
                }
                else {
                    this.ctrl.value.splice(0, 1, value);
                }
            }
        }
        else {
            this.ctrl.value.splice(0, 1, val);
        }
    }
    onEndChange(val) {
        if (val) {
            const value = Number(val);
            if (!isNaN(value)) {
                if (!this.ctrl.value || this.ctrl.value.length === 0) {
                    this.ctrl.value = [null, value];
                }
                else if (this.ctrl.value.length === 1) {
                    this.ctrl.value.push(value);
                }
                else {
                    this.ctrl.value.splice(1, 1, value);
                }
            }
        }
        else {
            this.ctrl.value.splice(1, 1, val);
        }
    }
    onFocus() {
        this.showKeyboard = true;
    }
    mounted() {
        this.$nextTick(() => {
            const headerEl = document.querySelector('.search-header');
            headerEl.addEventListener('click', this.hideKeyBoard, true);
        });
    }
    hideKeyBoard() {
        this.showKeyboard = false;
    }
};
InputNumberRange = tslib_1.__decorate([
    Component({
        name: "input-number-range",
        components: {
            H3Input
        }
    })
], InputNumberRange);
export default InputNumberRange;
